// 자동 생성 파일: node ai/scripts/sync-arcs.mjs (직접 고치지 않는다)
// 원본: ai/knowledge/arcs/*.json (막별 직업 방향·소품, 근거 카드는 draft), ai/knowledge/link-map.json (격국 기본 직업 분야, 오행별 소품)
export const ARC_DATA = {
  "arcs": {
    "건록격": {
      "yong": "별도",
      "acts": [
        {
          "act": 1,
          "theme": "힘을 쏟을 한 곳을 정하는 시기",
          "fields": [
            "관성",
            "재성",
            "식상"
          ],
          "traits": [
            "원칙",
            "열정"
          ],
          "props": [
            "일정표"
          ],
          "titlePhrase": "한 곳을 정하는",
          "cardIds": [
            "JP-건록월겁",
            "JP-건록"
          ]
        },
        {
          "act": 2,
          "theme": "정한 통로에 몰입할지 분산할지, 같은 기운의 사람과 경쟁할지 정하는 시기",
          "fields": [
            "관성",
            "재성"
          ],
          "traits": [
            "원칙",
            "열정"
          ],
          "props": [
            "업무 우선순위표"
          ],
          "titlePhrase": "몰입하는",
          "cardIds": [
            "JP-건록월겁",
            "JP-건록"
          ]
        },
        {
          "act": 3,
          "theme": "경쟁을 정리하고 같은 기운의 사람들과 몫을 나누는 시기",
          "fields": [
            "비겁",
            "관성"
          ],
          "traits": [
            "배려",
            "원칙"
          ],
          "props": [
            "합의서"
          ],
          "titlePhrase": "몫을 나누는",
          "cardIds": [
            "JP-건록월겁",
            "JP-건록"
          ]
        }
      ]
    },
    "상관격": {
      "yong": "역용",
      "acts": [
        {
          "act": 1,
          "theme": "재능과 표현을 드러내되 규칙·권위와 부딪치는 선택을 하는 시기",
          "fields": [
            "식상"
          ],
          "traits": [
            "열정",
            "신중"
          ],
          "props": [
            "작업 노트"
          ],
          "titlePhrase": "드러내는",
          "cardIds": [
            "JP-상관",
            "JP-순용역용"
          ]
        },
        {
          "act": 2,
          "theme": "재능이 일과 수입으로 이어지는지 확인하는 시기 (상관생재)",
          "fields": [
            "식상",
            "재성"
          ],
          "traits": [
            "열정",
            "신중"
          ],
          "props": [
            "의뢰서",
            "수입 장부"
          ],
          "titlePhrase": "수입으로 바꾸는",
          "cardIds": [
            "JP-상관",
            "JP-순용역용"
          ]
        },
        {
          "act": 3,
          "theme": "배움과 정리로 재능을 다스려 쓰거나 기준과 계속 부딪치는 시기 (상관패인)",
          "fields": [
            "식상",
            "인성"
          ],
          "traits": [
            "신중",
            "열정"
          ],
          "props": [
            "정리한 원고"
          ],
          "titlePhrase": "다스려 쓰는",
          "cardIds": [
            "JP-상관",
            "JP-순용역용"
          ]
        }
      ]
    },
    "정관격": {
      "yong": "순용",
      "acts": [
        {
          "act": 1,
          "theme": "규율과 책임을 맡을지, 규칙을 따를지 정하는 시기",
          "fields": [
            "관성"
          ],
          "traits": [
            "원칙",
            "신중"
          ],
          "props": [
            "출석 명부"
          ],
          "titlePhrase": "맡아 보는",
          "cardIds": [
            "JP-정관",
            "JP-순용역용"
          ]
        },
        {
          "act": 2,
          "theme": "자격과 수입이 책임을 뒷받침하는지 확인하며 맡은 범위를 넓히는 시기",
          "fields": [
            "관성",
            "인성",
            "재성"
          ],
          "traits": [
            "원칙",
            "신중"
          ],
          "props": [
            "결재 서류철",
            "도장"
          ],
          "titlePhrase": "책임을 넓히는",
          "cardIds": [
            "JP-정관",
            "JP-순용역용"
          ]
        },
        {
          "act": 3,
          "theme": "맡은 규율을 이어 가거나 넘기고, 자기 방식과의 충돌을 조율하는 시기",
          "fields": [
            "관성"
          ],
          "traits": [
            "원칙",
            "신중"
          ],
          "props": [
            "인수인계 문서"
          ],
          "titlePhrase": "넘겨주는",
          "cardIds": [
            "JP-정관",
            "JP-순용역용"
          ]
        }
      ]
    }
  },
  "defaults": {
    "건록격": {
      "fields": [
        "비겁",
        "관성",
        "재성"
      ]
    },
    "상관격": {
      "fields": [
        "식상"
      ]
    },
    "식신격": {
      "fields": [
        "식상",
        "재성"
      ]
    },
    "양인격": {
      "fields": [
        "관성",
        "비겁"
      ]
    },
    "월겁격": {
      "fields": [
        "비겁",
        "재성"
      ]
    },
    "정관격": {
      "fields": [
        "관성"
      ]
    },
    "정인격": {
      "fields": [
        "인성"
      ]
    },
    "정재격": {
      "fields": [
        "재성"
      ]
    },
    "편관격": {
      "fields": [
        "관성"
      ]
    },
    "편인격": {
      "fields": [
        "인성",
        "식상"
      ]
    },
    "편재격": {
      "fields": [
        "재성",
        "식상"
      ]
    }
  },
  "elementProps": {
    "목": [
      "화분",
      "종이 묶음",
      "나무 연필꽂이"
    ],
    "화": [
      "스탠드",
      "촛대",
      "붉은 노트"
    ],
    "토": [
      "도자기 컵",
      "보관 상자",
      "흙빛 방석"
    ],
    "금": [
      "금속 자",
      "도장",
      "작은 종"
    ],
    "수": [
      "유리컵",
      "잉크병",
      "물주전자"
    ]
  },
  "cards": {
    "DC-stem-갑": {
      "book": "적천수",
      "locator": "천간론 갑",
      "status": "draft",
      "verified": false
    },
    "DC-stem-을": {
      "book": "적천수",
      "locator": "천간론 을",
      "status": "draft",
      "verified": false
    },
    "DC-stem-병": {
      "book": "적천수",
      "locator": "천간론 병",
      "status": "draft",
      "verified": false
    },
    "DC-stem-정": {
      "book": "적천수",
      "locator": "천간론 정",
      "status": "draft",
      "verified": false
    },
    "DC-stem-무": {
      "book": "적천수",
      "locator": "천간론 무",
      "status": "draft",
      "verified": false
    },
    "DC-stem-기": {
      "book": "적천수",
      "locator": "천간론 기",
      "status": "draft",
      "verified": false
    },
    "DC-stem-경": {
      "book": "적천수",
      "locator": "천간론 경",
      "status": "draft",
      "verified": false
    },
    "DC-stem-신": {
      "book": "적천수",
      "locator": "천간론 신",
      "status": "draft",
      "verified": false
    },
    "DC-stem-임": {
      "book": "적천수",
      "locator": "천간론 임",
      "status": "draft",
      "verified": false
    },
    "DC-stem-계": {
      "book": "적천수",
      "locator": "천간론 계",
      "status": "draft",
      "verified": false
    },
    "DC-strength": {
      "book": "적천수",
      "locator": "강약·왕쇠 관련 장",
      "status": "draft",
      "verified": false
    },
    "DC-luck": {
      "book": "적천수",
      "locator": "세운·대운 관련 장",
      "status": "draft",
      "verified": false
    },
    "JP-정관": {
      "book": "자평진전",
      "locator": "論官",
      "status": "draft",
      "verified": false
    },
    "JP-편관": {
      "book": "자평진전",
      "locator": "論偏官",
      "status": "draft",
      "verified": false
    },
    "JP-정인": {
      "book": "자평진전",
      "locator": "論印綬",
      "status": "draft",
      "verified": false
    },
    "JP-편인": {
      "book": "자평진전",
      "locator": "論印綬 및 食神 항",
      "status": "draft",
      "verified": false
    },
    "JP-식신": {
      "book": "자평진전",
      "locator": "論食神",
      "status": "draft",
      "verified": false
    },
    "JP-상관": {
      "book": "자평진전",
      "locator": "論傷官",
      "status": "draft",
      "verified": false
    },
    "JP-정재": {
      "book": "자평진전",
      "locator": "論財",
      "status": "draft",
      "verified": false
    },
    "JP-편재": {
      "book": "자평진전",
      "locator": "論財",
      "status": "draft",
      "verified": false
    },
    "JP-건록월겁": {
      "book": "자평진전",
      "locator": "論建祿月劫",
      "status": "draft",
      "verified": false
    },
    "JP-건록": {
      "book": "자평진전",
      "locator": "확인 필요(建祿 항목)",
      "status": "draft",
      "verified": false
    },
    "JP-월겁": {
      "book": "자평진전",
      "locator": "확인 필요(月劫 항목)",
      "status": "draft",
      "verified": false
    },
    "JP-순용역용": {
      "book": "자평진전",
      "locator": "확인 필요(순용·역용을 다루는 장)",
      "status": "draft",
      "verified": false
    },
    "JP-양인": {
      "book": "자평진전",
      "locator": "論陽刃",
      "status": "draft",
      "verified": false
    },
    "JP-충합": {
      "book": "자평진전",
      "locator": "論刑沖會合解法",
      "status": "draft",
      "verified": false
    },
    "GT-겨울": {
      "book": "궁통보감",
      "locator": "조후 원칙(겨울 월)",
      "status": "draft",
      "verified": false
    },
    "GT-여름": {
      "book": "궁통보감",
      "locator": "조후 원칙(여름 월)",
      "status": "draft",
      "verified": false
    },
    "GT-봄가을": {
      "book": "궁통보감",
      "locator": "조후 원칙(봄·가을 월)",
      "status": "draft",
      "verified": false
    },
    "YH-비겁": {
      "book": "연해자평",
      "locator": "육친·십성 해설",
      "status": "draft",
      "verified": false
    },
    "YH-식상": {
      "book": "연해자평",
      "locator": "육친·십성 해설",
      "status": "draft",
      "verified": false
    },
    "YH-재성": {
      "book": "연해자평",
      "locator": "육친·십성 해설",
      "status": "draft",
      "verified": false
    },
    "YH-관성": {
      "book": "연해자평",
      "locator": "육친·십성 해설",
      "status": "draft",
      "verified": false
    },
    "YH-인성": {
      "book": "연해자평",
      "locator": "육친·십성 해설",
      "status": "draft",
      "verified": false
    }
  }
};
